import { motion } from "framer-motion";
import { PenLine, UploadCloud, Users, Rocket } from "lucide-react";
import { STEPS } from "@/data/landingData";

const ICONS = { PenLine, UploadCloud, Users, Rocket };

export const HowItWorks = () => {
  return (
    <section id="cara-kerja" className="relative py-24 lg:py-32">
      <div className="pointer-events-none absolute inset-0 grid-bg opacity-40" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400">Cara Kerja</span>
          <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Sekolah Digital dalam 4 Langkah
          </h2>
          <p className="mt-4 text-base text-slate-300">
            Dari pendaftaran hingga portal aktif, prosesnya cepat dan didampingi tim kami sepenuhnya.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.step}
                data-testid={`step-${s.step}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.1 }}
                className="relative rounded-2xl border border-cyan-500/15 glass p-6"
              >
                <div className="mb-4 font-heading text-4xl font-bold text-gradient">{s.step}</div>
                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-500/20 bg-cyan-950/40 text-cyan-400">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-heading text-base font-semibold text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
